const breadcrumbs = {
  accessLevels: 'Niveles de acceso',
  controllers: 'Controladores',
  credentials: 'Credenciales',
  dealerInfo: 'Información del distribuidor',
  dealerView: 'Vista del distribuidor',
  doors: 'Puertas',
  employees: 'Empleados',
  events: 'Eventos',
  firmwareManager: 'Gestor de firmware',
  floorPlans: 'Planos de planta',
  globalSettings: 'Configuraciones globales',
  hardware: 'Hardware',
  holidays: 'Días festivos',
  inputs: 'Entradas',
  interlocks: 'Interbloqueos',
  lockdown: 'Confinamiento',
  outputs: 'Salidas',
  reports: 'Reportes',
  schedules: 'Horarios',
  settings: 'Configuraciones',
  sites: 'Sitios',
  users: 'Usuarios',

  activate: 'Activar',
  create: 'Crear',
  edit: 'Editar',
  manage: 'Administrar',
};

export default breadcrumbs;
